BookingApp.filter('FlightFilter',function($filter){
    return function(input,Filter){
        var FilteredDate = [];
        //console.log(Filter);

        //Filtere By number of stops
        angular.forEach(input,function(value,key){
        var cf = Filter.CA.filter(function(n) {
                return value.ConnectingAirports.indexOf(n) !== -1;
            });
        var ah = $filter('date')(value.inBound.Dep,'HH');
        var aM = $filter('date')(value.inBound.Dep,'m');
        ah = parseInt(ah);
        if(parseInt(aM)) ah += 1;
        //console.log(Filter.NoConvenience + " == " + value.NoConvenience);
            if(
                (!Filter.Stops.length ||  Filter.Stops.indexOf(value.inBound.stops) !== -1)
                &&  (!Filter.Airline.length || Filter.Airline.indexOf(value.AirlineName) !== -1)
                &&  (!Filter.AA.length || Filter.AA.indexOf(value.ArrivalAirport) !== -1)
                &&  (!Filter.DA.length || Filter.DA.indexOf(value.DepartAirport) !== -1)
                &&  (!Filter.CA.length || cf.length )
                &&  (Filter.Price.minPrice <= value.Fare.TotalFare && Filter.Price.maxPrice >= value.Fare.TotalFare)
                &&  (!(Filter.Refundable.length) || (Filter.Refundable.indexOf(1) !== -1 && value.isRefundable) || (Filter.Refundable.indexOf(0) !== -1 && !value.isRefundable))
                &&  (!(Filter.Lcc.length) || (Filter.Lcc.indexOf(1) !== -1 && value.IsLCC) || (Filter.Lcc.indexOf(0) !== -1 && !value.IsLCC))
                &&  (!Filter.NoConvenience || Filter.NoConvenience == value.NoConvenience)
                &&  (!Filter.BA || Filter.BA == value.BA)
                &&  (
                        (!Filter.IEMFT || (0 < ah && 8 >= ah))
                        &&  (!Filter.IMFT || (8 < ah && 12 >= ah))
                        &&  (!Filter.IMDFT || (12 < ah && 16 >= ah))
                        &&  (!Filter.INFT || (16 < ah && 24 >= ah))
                    )
            ){
                FilteredDate.push(value);
            }
        });
        //console.log(FilteredDate);
        return FilteredDate;
    }
})
